import React from 'react';
import styled from 'styled-components';
import MediaQuery from "react-responsive";
import PropTypes from 'prop-types';

import { WeekDaysWrapper } from './WeekDays';
import { HighlightedCalendarDate, TodayCalendarDate, CalendarDate, DayDateCell, DayMonthCell, SelectedCalendarDate } from './CalendarCells';
import { monthShortName } from '../../../shared/constants';
import Icon from '../Icon/Icon';
import Swipe from '../Swipe/Swipe';
import './Days.css';

const DaysWrapper = styled(WeekDaysWrapper)`
  background-color: #ffffff;
  color: #626262;
  font-weight: normal;
  padding: 8px 0px;
  border: solid 1px #e9eff4;
  box-shadow: 0 2px 9px 0 rgba(0,0,0,0.03);
  border-radius: 3px;
  border-top-left-radius:0;
  border-top-right-radius:0;

  @media(min-width: 361px) {    
    padding: 8px;
  }
  @media(min-width: 800px) {    
    padding: 12px 0;
  }
`;

const DaysContent = (props) => {
  const today = new Date();
  today.setHours(0);
  today.setMinutes(0);
  today.setSeconds(0);

  let dateComponentClass = "";
  if (props.calendarFirstDate === true) {
    dateComponentClass = "first-selected-date";
  }

  return (
    <React.Fragment>
      {props.getWeekDays().map((day, index) => {

        let alreadySelected = false;
        if (props.daysSelected) {
          if (props.daysSelected.some(item => (item.date.getDate() + "/" + parseInt(item.date.getMonth() + 1) + "/" + item.date.getFullYear()) === (day.getDate() + "/" + parseInt(day.getMonth() + 1) + "/" + day.getFullYear()))) {
            alreadySelected = true;
          }
        }

        let activeClass = "";
        if (props.current) {
          activeClass = props.isSameDay(day, props.current) ? "current-selected-date" : "";
        }

        let previousDays = "";
        if (day < today) {
          previousDays = "previous-days";
        }

        const month = monthShortName[day.getMonth()];
        const DateComponent = props.isSameDay(day, props.current)
          ? HighlightedCalendarDate
          : props.isSameDay(day, props.today)
            ? TodayCalendarDate
            : CalendarDate;
        return (
          <DateComponent
            key={day.getDate()}
            index={index + props.indexOffset}
            onClick={() => props.handleSelect(day)}
            disabled={(day < today) ? true : false}
            alreadySelected={alreadySelected}
            className={alreadySelected === true ? activeClass + " date-col selected" : "date-col " + dateComponentClass + " " + activeClass + " " + previousDays}
          >
            <DayMonthCell alreadySelected={alreadySelected} >{month}</DayMonthCell>
            <DayDateCell alreadySelected={alreadySelected}>{day.getDate()}</DayDateCell>
          </DateComponent>
        )
      })}
    </React.Fragment>
  )
}

const Days = (props) => {
  return (
    <DaysWrapper className="days-list">
      <MediaQuery query="(max-device-width: 768px)"> {/* -----to be uncommmented-----*/}
        {/* <Swipe 
          key={`swipeItem-dateselector-1`} 
          handleSwipeLeft={props.handlePreviousWeek} 
          handleSwipeRight={props.handleNextWeek} 
        > */}
        <DaysContent {...props} indexOffset={0} />
        {/* </Swipe> */}
      </MediaQuery>
      <MediaQuery query="(min-device-width: 769px)">  {/*-----to be uncommmented-----*/}
        <CalendarDate key={99}
          index={0}
          onClick={() => props.handlePreviousWeek()}
          className="left-icon"
        >
          <Icon
            icon="calendar-prev-week-icon"
          />
        </CalendarDate>
        <DaysContent {...props} indexOffset={1} />
        <CalendarDate key={98} index={8}
          onClick={() => props.handleNextWeek()}
          className="right-icon"
        >
          <Icon
            icon="calendar-next-week-icon"
          />
        </CalendarDate>
      </MediaQuery> {/*-----to be uncommmented-----*/}
    </DaysWrapper>
  )
}

Days.propTypes = {
  handlePreviousWeek: PropTypes.func,
  handleNextWeek: PropTypes.func,
  getWeekDays: PropTypes.func,
  current: PropTypes.object,
  handleSelect: PropTypes.func,
  today: PropTypes.object
};

Days.defaultProps = {
  current: null,
  today: null
};

export default Days;


// WEBPACK FOOTER //
// ./src/components/UI/DateSelector/Days.js